<template>
<div class="grid ">	

<div class="col-12 ">
<h4 class="text-primary">Modül Çıktı Öğelerini Seçin</h4>
</div>

<div class="col-12 pb-5">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_output_type" :options="output_options" optionLabel="name"   class="w-full p-inputtext-sm" @change="outputTypeSelected"/>
<label  class="text-primary">Bir Veri Türü Seçin</label>
</span>
</div>


<template v-if="selected_output_type">

<div class="col-12 pb-5" >
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_output" :options="outputlist" optionLabel="name"   class="w-full p-inputtext-sm" @change="outputSelected"/>
<label  class="text-primary">{{selected_output_type.name}}</label>
</span>
</div>


<template v-if="show_period">
<div class="col-12 pb-5" v-if="periods_loaded">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_projectperiod" :options="projectperiods" optionLabel="name"   class="w-full p-inputtext-sm" @change="periodSelected"/>
<label  class="text-primary">Dönem</label>
</span>
</div>
</template>





<template v-if="sections_loaded && selected_projectperiod">
<div class="col-12 pb-5" v-if="selected_output_type.id=='section_points' ||  selected_output_type.id=='section_nonconformities'">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_section" :options="sections" optionLabel="name"   class="w-full p-inputtext-sm" @change="sectionSelected"/>
<label  class="text-primary">Bölüm</label>
</span>
</div>






<template v-if=" selected_output_type.id=='section_nonconformities'">
<template v-if="!nonconformitytypes.length">
  <p class="text-purple-500 bold pl-2">Bu soru listesi için belirlenmiş uygunsuzluk türü bulunmuyor</p>
</template>
<template v-else>
<div class="col-12 pb-5" >
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_nonconformity_type" :options="nonconformitytypes" optionLabel="name"   class="w-full p-inputtext-sm" >

<template #option="slotProps">
<div class="overloadtext">{{slotProps.option.name}}</div>
</template>

</Dropdown>

<label  class="text-primary">Uygunsuzluk Türü</label>
</span>
</div>

<div class="col-12 pb-5" >
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_nonconformity_output_type" :options="nonconformity_output_options" optionLabel="name"    class="w-full p-inputtext-sm" >

<template #option="slotProps">
<div class="overloadtext">{{slotProps.option.name}}</div>
</template>

</Dropdown>

<label  class="text-primary">Uygunsuzluk Çıktı Türü</label>
</span>
</div> 
</template>


</template>


</template>


<div class="col-12 pb-5" v-if="selected_output_type.id=='questionlist_custom_points' && custom_calculations_loaded">
<span class="p-float-label">

<Dropdown :filter="true"  v-model="selected_custom_calculation" :options="customcalculations" optionLabel="name"   class="w-full p-inputtext-sm" @change="customCalculationSelected"/>
<label  class="text-primary">Hesaplama</label>

</span>

</div>





<div class="col-12 pb-5" v-if="selected_output_type.id=='inputfield_point' && inputfields_loaded">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_inputfield" :options="inputfields" optionLabel="name"   class="w-full p-inputtext-sm" @change="inputfieldSelected">
  <template #option="slotProps">
<div class="overloadtext">{{slotProps.option.name}}</div>
</template>

</Dropdown>
<label  class="text-primary">Soru</label>
</span>
</div>

<div class="col-12 pb-5" v-if="selected_output_type.id=='inputfield_nonconformity_count' && inputfields_loaded">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_inputfield" :options="inputfields" optionLabel="name"   class="w-full p-inputtext-sm" @change="inputfieldSelected">
  <template #option="slotProps">
<div class="overloadtext">{{slotProps.option.name}}</div>
</template>

</Dropdown>
<label  class="text-primary">Soru</label>
</span>
</div>



<div class="col-12 pb-5" v-if="selected_output_type.id=='inputfield_submission' && inputfields_loaded">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_inputfield" :options="inputfields" optionLabel="name"   class="w-full p-inputtext-sm" @change="inputfieldSelected">

<template #option="slotProps">
<div class="overloadtext">{{slotProps.option.name}}</div>
</template>

</Dropdown>

<label  class="text-primary">Soru</label>
</span>
</div>

<div class="col-12 pb-5" v-if="selected_output_type.id=='inputfield_auditor_note' && inputfields_loaded">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_inputfield" :options="inputfields" optionLabel="name"   class="w-full p-inputtext-sm" @change="inputfieldSelected">

<template #option="slotProps">
<div class="overloadtext">{{slotProps.option.name}}</div>
</template>

</Dropdown>

<label  class="text-primary">Soru</label>
</span>
</div>

<div class="col-12 pb-5" v-if="selected_output_type.id=='inputfield_supplier_note' && inputfields_loaded">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_inputfield" :options="inputfields" optionLabel="name"   class="w-full p-inputtext-sm" @change="inputfieldSelected">

<template #option="slotProps">
<div class="overloadtext">{{slotProps.option.name}}</div>
</template>

</Dropdown>

<label  class="text-primary">Soru</label>
</span>
</div>



<template v-if="selected_inputfield && selected_inputfield.type=='columns'">
<div class="col-12 pb-5">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_column" :options="inputfieldcolumns" optionLabel="name"   class="w-full p-inputtext-sm" />
<label  class="text-primary">Sütun</label>
</span>
</div>
</template>

<template v-if="selected_inputfield && selected_inputfield.type=='location'">
<div class="col-12 pb-5">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_column" :options="location_output_options" optionLabel="name"   class="w-full p-inputtext-sm" />
<label  class="text-primary">Sütun</label>
</span>
</div>
</template>


<div class="col-12 pb-5" v-if="selected_output_type.id=='inputfield_null_reason' && inputfields_loaded">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_inputfield" :options="inputfields" optionLabel="name"   class="w-full p-inputtext-sm" @change="inputfieldSelected">

<template #option="slotProps">
<div class="overloadtext">{{slotProps.option.name}}</div>
</template>

</Dropdown>

<label  class="text-primary">Soru</label>
</span>
</div>





<template v-if="selected_output_type.id=='questionlist_nonconformity_count' && nonconformitytypes_loaded && selected_projectperiod">

<div class="col-12 pb-5" >
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_nonconformity_type" :options="nonconformitytypes" optionLabel="name"   class="w-full p-inputtext-sm" >

<template #option="slotProps">
<div class="overloadtext">{{slotProps.option.name}}</div>
</template>

</Dropdown>

<label  class="text-primary">Uygunsuzluk Türü</label>
</span>
</div>

<div class="col-12 pb-5" >
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_nonconformity_output_type" :options="nonconformity_output_options" optionLabel="name"    class="w-full p-inputtext-sm" >

<template #option="slotProps">
<div class="overloadtext">{{slotProps.option.name}}</div>
</template>

</Dropdown>

<label  class="text-primary">Uygunsuzluk Çıktı Türü</label>
</span>
</div>




</template>



<div class="col-12 pb-5" >
<div class="flex align-items-center justify-content-end">
<Button label="İptal"  class="p-button-outlined p-button-sm p-button-danger mr-2"   @click="cancelOutput"></Button>
<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary"   @click="addOutput"></Button>
</div>
</div>




</template>






<!--
<div class="col-12 pb-5">
<span class="p-float-label">


<CascadeSelect v-model="selected_questionlist" 
:options="questionlists" 
optionLabel="name" 
optionGroupLabel="name"
:optionGroupChildren="['options']" 
class="w-full p-inputtext-sm"
@change="questionlistSelected"
 />


<label  class="text-primary">Soru Listeleri</label>
</span>
</div>
-->









<div class="col-12 ">	
<h4 class="text-purple-500 mb-0">Modül Çıktıları</h4>
</div>
<div class="col-12 ">
<p v-for="item in selectednode.data.outputs" class="mb-3 mt-1">
	
<RemovableChip :item="item"  @removeItem="removeItem"></RemovableChip>



</p>



</div>



</div>	
</template>

<script>
import RemovableChip from "./RemovableChip"
export default {

  name: 'SupplierNodeData',
  props:["projects","flows","custom_attributes","questionlists"],
  data () {
    return {    	
    	output_options:[
      {name:"Proje Durumu",id:"project_status"},
      {name:"Aşama Durumu",id:"flow_status"},
      {name:"Özel Nitelik",id:"custom_attribute"},
      {name:"Tedarikçi Adres",id:"supplier_location"},
      {name:"Tedarikçi Kullanıcıları",id:"supplier_users"},
      {name:"Son Tedarikçi Görüşmesi",id:"last_supplier_conversation"},
      {name:"Aşama Puanı",id:"questionlist_points"},
      {name:"Aşama Özel Puanı",id:"questionlist_custom_points"},
      {name:"Aşama Uygunsuzluk Sayısı",id:"questionlist_nonconformity_count"},
      {name:"Aşama Bölüm Puanı",id:"section_points"},
      {name:"Aşama Bölüm Uygunsuzluk Sayısı",id:"section_nonconformities"},
      {name:"Aşama Soru Puanı",id:"inputfield_point"},
      {name:"Aşama Soru Verisi",id:"inputfield_submission"},
      {name:"Aşama Soru Boş Bırakma Nedeni",id:"inputfield_null_reason"},
      {name:"Aşama Soru Uygunsuzluk Durumu",id:"inputfield_nonconformity_count"},
      {name:"Aşama Soru Denetçi Notu",id:"inputfield_auditor_note"},
      {name:"Aşama Soru Tedarikçi Açıklaması",id:"inputfield_supplier_note"},
      {name:"Doğrulama Denetçisi",id:"verification_auditor"},
      {name:"Denetleme Denetçisi",id:"audit_auditor"},
      {name:"Doğrulama Tarihi",id:"verification_date"},
      {name:"Denetleme Tarihi",id:"audit_date"},
      {name:"Doğrulama Durumu",id:"verification_status"},
      {name:"Denetleme Durumu",id:"audit_status"},
      ],
      nonconformity_output_options:[
      {name:"Tüm Uygunsuzluk Toplamı",id:"all_count"},
      {name:"Açık Uygunsuzluk Toplamı",id:"open_count"},
      {name:"Kapalı Uygunsuzluk Toplamı",id:"closed_count"},
      {name:"Reddedilen Uygunsuzluk Toplamı",id:"refused_count"},
      {name:"Kabuledilen Uygunsuzluk Toplamı",id:"accepted_count"},
      {name:"Değerlendirmedeki Uygunsuzluk Toplamı",id:"pending_count"},
      ],
      supplier_user_options:[
      {name:"İlk kullanıcı",id:"first_user"},
      {name:"Tüm kullanıcılar",id:"all_users"},
      ],
      supplier_conversation_options:[      
      {name:"Tümü",id:"all"},
      {name:"Genel",id:"general"},
      ],
      location_output_options:[
      {name:"Ülke",id:"country"},
      {name:"Şehir",id:"city"},
      {name:"Adres",id:"address"},
      {name:"Enlem",id:"latitude"},
      {name:"Boylam",id:"longitude"},
      {name:"Posta Kodu",id:"zipcode"},
      ],
    	loading_list:false,
    	selected_output_type:null,
    	outputlist:[],
      customcalculations:[],
      show_period:false,
    	show_outputlist:false,
    	selected_output:null,
    	output_type_title:null,
    	projectperiods:[],
    	sections:[],
    	inputfields:[],
    	inputfieldcolumns:[],
      nonconformitytypes:[],
    	selected_projectperiod:null,
    	selected_section:null,
    	selected_inputfield:null,
    	selected_column:null,
      selected_custom_calculation:null,
      selected_nonconformity_type:null,
      selected_nonconformity_output_type:null,
      selected_location_output_type:null,
      periods_loaded:false,
      nonconformitytypes_loaded:false,
    	sections_loaded:false,
    	inputfields_loaded:false,
    	columns_loaded:false,
      custom_calculations_loaded:false,
    }
  },
  components:{RemovableChip},
  computed:
  {
  	selectednode()
  	{
  		return this.$store.state.calculations.selectednode
      
  	},
  },
  methods:{
  	itemchip(item)
  	{
  		if(item.type=='project_status')
  		{
  			return item.name+' - Proje Durumu'
  		}
  		if(item.type=='flow_status')
  		{
  			return item.name+' - Aşama Durumu'
  		}
  		if(item.type=='custom_attribute')
  		{
  			return item.name+' -  Özel Nitelik'
  		}
  		if(item.type=='questionlist_points')
      {
        return item.name+' - Aşama Puanı'
      }
      if(item.type=='questionlist_custom_points')
      {
        return item.name+' - Aşama Özel Puanı'
      }
      if(item.type=='section_points')
      {
        return item.name+' - Aşama Bölüm Puanı'
      }
      if(item.type=='section_nonconformities')
      {
        return item.name+' - Aşama Bölüm Uygunsuzluk Sayısı'
      }
  		if(item.type=='inputfield_point')
  		{
  			return item.name+' - Aşama Soru Puanı'
  		}
  		if(item.type=='inputfield_submission')
      {
        return item.name+' - Aşama Soru Verisi'
      }

      if(item.type=='inputfield_null_reason')
      {
        return item.name+' - Aşama Soru Boş Bırakma Nedeni'
      }
  		if(item.type=='questionlist_nonconformity_count')
      {
        return item.name+' -  Aşama Uygunsuzluk Sayısı'
      }
      if(item.type=='inputfield_nonconformity_count')
      {
        return item.name+' -  Aşama Soru Uygunsuzluk Sayısı'
      }
      if(item.type=='inputfield_auditor_note')
      {
        return item.name+' -  Aşama Soru Denetçi Notu'
      }
      if(item.type=='inputfield_supplier_note')
      {
        return item.name+' -  Aşama Soru Tedarikçi Açıklaması'
      }
  	},
  	cancelOutput()
  	{
  			this.selected_output_type = null
  			this.selected_section = null
  			this.selected_inputfield = null
  			this.selected_column = null
  			this.inputfields_loaded = false
  			this.sections_loaded = false
  			this.selected_projectperiod = false
        this.periods_loaded = false
        this.nonconformitytypes_loaded = false
  	},
  	addOutput()
  	{
  		console.log("selected_output")
  		console.log( this.selected_output)
  		let obj = {
  			name:null,
  			stack_id:Math.floor(Date.now() / 10),
  			id:null,
  			type:null,
        flow_id:null,
  			period_id:null,
  			custom_attribute_type:null,
  			inputfield_type:null,
  			column_id:null,
        column_type:null,
        nonconformitytype:null,
        nonconformity_output_type:null,
        location_output_type:null,
        user_output_type:null,
        conversation_output_type:null,
        audit_data_type:null,
        verification_data_type:null,
        custom_calculation_id:null,
  		}
  		let node = this.sanitizeArray(this.$store.state.calculations.selectednode)
  		//let ind = node.data.outputs.findIndex((item)=>{return item.id == this.selected_output.id && item.type == this.selected_output_type.id})
      let ind = -1
  		if(ind==-1)
  		{

        if(this.selected_output_type.id=='verification_auditor')
        {
          obj.verification_data_type = "auditor"
          obj.name = "Doğrulama Denetçisi - " +this.selected_output.name
          obj.period_id = this.selected_projectperiod.id
          obj.period_name = this.selected_projectperiod.name
          obj.id = this.selected_output.id
        }
        if(this.selected_output_type.id=='audit_auditor')
        {
          obj.verification_data_type = "auditor"
          obj.name = "Denetleme Denetçisi - " +this.selected_output.name
          obj.period_id = this.selected_projectperiod.id
          obj.period_name = this.selected_projectperiod.name
          obj.id = this.selected_output.id
        }

        if(this.selected_output_type.id=='verification_date')
        {
          obj.verification_data_type = "date"
          obj.name = "Doğrulama Tarihi - " +this.selected_output.name
          obj.period_id = this.selected_projectperiod.id
          obj.period_name = this.selected_projectperiod.name
          obj.id = this.selected_output.id
        }
        if(this.selected_output_type.id=='audit_date')
        {
          obj.verification_data_type = "date"
          obj.name = "Denetleme Tarihi - " +this.selected_output.name
          obj.period_id = this.selected_projectperiod.id
          obj.period_name = this.selected_projectperiod.name
          obj.id = this.selected_output.id
        }
        if(this.selected_output_type.id=='verification_status')
        {
          obj.verification_data_type = "date"
          obj.name = "Doğrulama Durumu - " +this.selected_output.name
          obj.period_id = this.selected_projectperiod.id
          obj.period_name = this.selected_projectperiod.name
          obj.id = this.selected_output.id
        }
        if(this.selected_output_type.id=='audit_status')
        {
          obj.verification_data_type = "date"
          obj.name = "Denetleme Durumu - " +this.selected_output.name
          obj.period_id = this.selected_projectperiod.id
          obj.period_name = this.selected_projectperiod.name
          obj.id = this.selected_output.id
        }

        if(this.selected_output_type.id=='supplier_users')
        {
          obj.user_output_type = this.selected_output.id
          obj.name = "Tedarikçi Kullanıcısı  - " +this.selected_output.name
        }

        if(this.selected_output_type.id=='last_supplier_conversation')
        {
          obj.conversation_output_type = this.selected_output.id
          obj.name = "Son tedarikçi görüşmesi "
        }
  			
  			if(this.selected_output_type.id=="project_status" || this.selected_output_type.id=="flow_status" ||  this.selected_output_type.id=="questionlist_points"  )
        {
          if(this.selected_output_type.id=="project_status")
          {
            obj.name = this.selected_output.name + " - Proje Durumu"
          }

          if(this.selected_output_type.id=="flow_status")
          {
            obj.name = this.selected_output.name + " - Aşama Durumu"
          }

          if(this.selected_output_type.id=="questionlist_points")
          {
            obj.name = this.selected_output.name + " - Aşama Puanı"
          }
          
          obj.id = this.selected_output.id
          obj.period_id = this.selected_projectperiod.id
          obj.period_name = this.selected_projectperiod.name
        }

        if(this.selected_output_type.id=="questionlist_custom_points"  )
        {
          
          obj.name = this.selected_output.name +" - Özel Puan - "+this.selected_custom_calculation.name
          obj.id = this.selected_output.id
          obj.period_id = this.selected_projectperiod.id
          obj.period_name = this.selected_projectperiod.name
          obj.custom_calculation_id = this.selected_custom_calculation.id
        }

        if(this.selected_output_type.id=="questionlist_nonconformity_count" )
        {
          
          obj.name = this.selected_output.name + " "+this.selected_nonconformity_type.name + " "+this.selected_nonconformity_output_type.name
          obj.id = this.selected_output.id
          obj.period_id = this.selected_projectperiod.id
          obj.period_name = this.selected_projectperiod.name
          obj.nonconformitytype = this.selected_nonconformity_type.id
          obj.nonconformity_output_type = this.selected_nonconformity_output_type.id
        }

        if(this.selected_output_type.id=="supplier_location" )
        {
          
          obj.name = this.selected_output.name 
          obj.id = this.selected_output.id
          obj.location_output_type = this.selected_location_output_type
        }
  			
  			if(this.selected_output_type.id=="custom_attribute")
  			{
  				obj.name = this.selected_output.name
  				obj.id = this.selected_output.id
  				obj.custom_attribute_type = this.selected_output.type
  			}

  			if(this.selected_output_type.id=="section_points")
        {
          console.log("section_points")
          console.log(this.selected_output.id)
          obj.name = this.selected_section.name 
          obj.id = this.selected_section.id
          obj.period_id = this.selected_projectperiod.id
          obj.flow_id = this.selected_output.id
          obj.period_name = this.selected_projectperiod.name
        }

        if(this.selected_output_type.id=="section_nonconformities")
        {
          obj.name = this.selected_output.name +" "+this.selected_section.name+ " "+this.selected_nonconformity_type.name + " "+this.selected_nonconformity_output_type.name
          obj.id = this.selected_section.id
          obj.period_id = this.selected_projectperiod.id
          obj.period_name = this.selected_projectperiod.name
          obj.nonconformitytype = this.selected_nonconformity_type.id
          obj.nonconformity_output_type = this.selected_nonconformity_output_type.id
        }
  			if(this.selected_output_type.id=="inputfield_point" || this.selected_output_type.id=="inputfield_nonconformity_count" || this.selected_output_type.id=="inputfield_auditor_note"  || this.selected_output_type.id=="inputfield_supplier_note" )
  			{
  				
  				obj.name = this.selected_inputfield.name 
  				obj.id = this.selected_inputfield.id
          obj.period_id = this.selected_projectperiod.id
          obj.flow_id = this.selected_output.id
          obj.period_name = this.selected_projectperiod.name
  			}
        if(this.selected_output_type.id=="inputfield_null_reason")
        {
            obj.name = this.selected_inputfield.name +" - Boş Bırakma Nedeni"          
            obj.id = this.selected_inputfield.id
            obj.inputfield_type = this.selected_inputfield.type
            obj.flow_id = this.selected_output.id
            obj.period_id = this.selected_projectperiod.id
        }

  			if(this.selected_output_type.id=="inputfield_submission")
  			{
  				if(this.selected_inputfield.type=="columns")
  				{
  					obj.name = this.selected_inputfield.name + " - " +this.selected_column.name
  					obj.id = this.selected_inputfield.id
  					obj.inputfield_type = this.selected_inputfield.type
  					obj.column_id = this.selected_column.id
  					obj.column_type = this.selected_column.type
  					obj.period_id = this.selected_projectperiod.id
            obj.flow_id = this.selected_output.id
            obj.period_name = this.selected_projectperiod.name
  				}
          else if(this.selected_inputfield.type=="location")
          {
            obj.name = this.selected_inputfield.name + " - " +this.selected_column.name
            obj.id = this.selected_inputfield.id
            obj.inputfield_type = this.selected_inputfield.type
            obj.column_id = this.selected_column.id
            obj.period_id = this.selected_projectperiod.id
            obj.flow_id = this.selected_output.id
            obj.period_name = this.selected_projectperiod.name
          }
  				else
  				{
  					obj.name = this.selected_inputfield.name  					
  					obj.id = this.selected_inputfield.id
  					obj.inputfield_type = this.selected_inputfield.type
            obj.flow_id = this.selected_output.id
  					obj.period_id = this.selected_projectperiod.id
  				}
  				
  			}

  			obj.type = this.selected_output_type.id

  			console.log("obj")
  			console.log(obj)
  			
  			
  			node.data.outputs.push(obj)
  			let nodes = this.$store.state.calculations.nodes
  			let node_ind = nodes.findIndex((item)=>{return item.id == node.id})
  			nodes[node_ind] = node
  			this.$store.dispatch('calculations/setNodes',nodes)
  			this.$store.dispatch('calculations/setSelectedNode',node)
  		}
  		setTimeout(()=>{
  			this.selected_output_type = null
  			this.selected_section = null
  			this.selected_inputfield = null
  			this.selected_column = null
  			this.inputfields_loaded = false
  			this.sections_loaded = false
  			this.selected_projectperiod = false
        this.periods_loaded = false
        this.nonconformitytypes_loaded = false
  		},10)  	
  	},
  	async outputTypeSelected()
  	{
  		
  		this.show_outputlist = true
  		this.loading_list = true
      this.selected_output = null
      this.selected_projectperiod = null
      this.show_period = false
      this.selected_section = null

  		if(this.selected_output_type.id=="verification_auditor")
      {
        await this.getVerificationFlows()
      }

      if(this.selected_output_type.id=="audit_auditor")
      {
        await this.getAuditFlows()
      }

      if(this.selected_output_type.id=="verification_date" || this.selected_output_type.id=="verification_status")
      {
        await this.getVerificationFlows()
      }

      if(this.selected_output_type.id=="audit_date" || this.selected_output_type.id=="audit_status")
      {
        await this.getAuditFlows()
      }

      if(this.selected_output_type.id=="project_status")
      {
        await this.getProjects()
      }

      if(this.selected_output_type.id=="supplier_location")
      {
        this.outputlist = await this.location_output_options
      }

      if(this.selected_output_type.id=="supplier_users")
      {
        this.outputlist = await this.supplier_user_options
      }
      if(this.selected_output_type.id=="last_supplier_conversation")
      {
        await this.getProjects()
        this.outputlist = await this.outputlist.concat(this.supplier_conversation_options)
      }

  		if(this.selected_output_type.id=="flow_status")
  		{
  			await this.getFlows()
  		}
  		if(this.selected_output_type.id=="custom_attribute")
  		{
  			await this.getCustomAttributes()
  		}
  		if(this.selected_output_type.id=="questionlist_points" || this.selected_output_type.id=="questionlist_custom_points" ||  this.selected_output_type.id=="section_points" || this.selected_output_type.id=="inputfield_point" || this.selected_output_type.id=="inputfield_submission" ||this.selected_output_type.id=="inputfield_null_reason" || this.selected_output_type.id=="questionlist_nonconformity_count" || this.selected_output_type.id=="inputfield_nonconformity_count" || this.selected_output_type.id=="section_nonconformities" || this.selected_output_type.id=="inputfield_auditor_note" || this.selected_output_type.id=="inputfield_supplier_note")
  		{
  			//await this.getQuestionlists()
  			await this.getFlows()
  		}
  		

  		this.loading_list = true  			
  		
  			
  	},
  	outputSelected()
  	{
  		console.log("outputSelected")
  		this.inputfields_loaded = false
  		this.sections_loaded = false
      this.periods_loaded = false
      this.nonconformitytypes_loaded = false
      this.show_period = true
      this.selected_section = null
  		console.log(this.selected_output)

  		if(this.selected_output_type.id=='project_status' )
  		{  			
  			this.getProjectPeriods(this.selected_output.id)
  		}
  		if(this.selected_output_type.id=='flow_status')
      {       
        this.getProjectPeriods(this.selected_output.project_id)
      }

      if(this.selected_output_type.id=='verification_auditor')
      {       
        this.getProjectPeriods(this.selected_output.project_id)
      }

      if(this.selected_output_type.id=='audit_auditor')
      {       
        this.getProjectPeriods(this.selected_output.project_id)
      }

      if(this.selected_output_type.id=='verification_date')
      {       
        this.getProjectPeriods(this.selected_output.project_id)
      }

      if(this.selected_output_type.id=='audit_date')
      {       
        this.getProjectPeriods(this.selected_output.project_id)
      }
      if(this.selected_output_type.id=='verification_status')
      {       
        this.getProjectPeriods(this.selected_output.project_id)
      }
      if(this.selected_output_type.id=='audit_status')
      {       
        this.getProjectPeriods(this.selected_output.project_id)
      }

  		if(this.selected_output_type.id=='questionlist_points' || this.selected_output_type.id=='questionlist_nonconformity_count')
      {       
        this.getProjectPeriods(this.selected_output.project_id)        
      }

      if(this.selected_output_type.id=='questionlist_custom_points')
      {       
        //console.log(this.selected_output)
        this.getProjectPeriods(this.selected_output.project_id)
        this.getCustomCalculations(this.selected_output.questionlist_id)        
      }

  		if(this.selected_output_type.id=='section_points' || this.selected_output_type.id=='section_nonconformities')
  		{
  			this.getProjectPeriods(this.selected_output.project_id)
  		}
  		if(this.selected_output_type.id=='inputfield_point' || this.selected_output_type.id=='inputfield_nonconformity_count' || this.selected_output_type.id=='inputfield_auditor_note' || this.selected_output_type.id=='inputfield_supplier_note')
  		{
  			this.getProjectPeriods(this.selected_output.project_id)
  		}
  		if(this.selected_output_type.id=='inputfield_submission')
      {
        this.getProjectPeriods(this.selected_output.project_id)
      }
      if(this.selected_output_type.id=='inputfield_null_reason')
      {
        this.getProjectPeriods(this.selected_output.project_id)
      }

      if(this.selected_output_type.id=='supplier_users')
      {
        
      }

  	},
  	sectionSelected()
  	{
  		//this.addOutput()
      console.log(this.selected_section)
      if(this.selected_output_type.id=="section_nonconformities")
      {
        this.getNonconformityTypes(this.selected_section.questionlist_id)
      }
      

  	},
  	periodSelected()
  	{

        console.log(this.selected_projectperiod)

      if(this.selected_output_type.id=='questionlist_points' || this.selected_output_type.id=='questionlist_nonconformity_count' || this.selected_output_type.id=='questionlist_custom_points')
      {           
        this.getNonconformityTypes(this.selected_output.questionlist_id)
      }

      if(this.selected_output_type.id=='section_points' || this.selected_output_type.id=='section_nonconformities')
      {
        this.getQuestionlistSections(this.selected_output.questionlist_id)
      }
      if(this.selected_output_type.id=='inputfield_point' || this.selected_output_type.id=='inputfield_nonconformity_count' || this.selected_output_type.id=='inputfield_auditor_note'|| this.selected_output_type.id=='inputfield_supplier_note')
      {
        this.getQuestionlistInputfields(this.selected_output.questionlist_id)
      }
      if(this.selected_output_type.id=='inputfield_submission')
      {
        this.getQuestionlistInputfields(this.selected_output.questionlist_id)
      }
      if(this.selected_output_type.id=='inputfield_null_reason')
      {
        this.getQuestionlistInputfields(this.selected_output.questionlist_id)
      }

  	},
  	inputfieldSelected()
    {
      if(this.selected_inputfield.type=="columns")
      {
        this.getInputfieldColumns()
      }
      else
      {
        //this.addOutput()
      }
    },

    customCalculationSelected()
    {
      console.log("customCalculationSelected")
      this.show_period = true
    },
  	async getInputfieldColumns()
  	{
  		this.inputfieldcolumns = await this.generalApiGetWithoutLoader("questionlists/inputfield/columns/"+this.selected_inputfield.id)
  		this.columns_loaded = true
  		
  	},
  	async getCustomAttributes()
  	{
  		let outputlist = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$route.params.id)
      for(let item of outputlist)
      {
        if(item.group)
        {
          item.name = item.name + " ("+item.group.name+")"
        }
      }
      this.outputlist = outputlist
  		console.log(this.outputlist)
  	},
  	async getProjects()
    {
      this.outputlist = await this.generalApiGetWithoutLoader("brand_projects/"+this.$route.params.id)
    },
    async getVerificationFlows()
    {
      this.outputlist = await this.generalApiGetWithoutLoader("brand_verifications/"+this.$route.params.id)
    },

    async getAuditFlows()
    {
      this.outputlist = await this.generalApiGetWithoutLoader("brand_audits/"+this.$route.params.id)
    },
  	async getFlows()
    {
      this.outputlist = await this.generalApiGetWithoutLoader("brand/flows/"+this.$route.params.id)
    },
    async getCustomCalculations(questionlist_id)
    {
      console.log("getCustomCalculations")
      this.customcalculations = await this.generalApiGetWithoutLoader("flow_custom_calculations/"+questionlist_id)
      //console.log(this.customcalculations)
      this.custom_calculations_loaded = true
    },
  	async getQuestionlists()
  	{
  		this.outputlist = await this.generalApiGetWithoutLoader("brand/brand_questionlists/"+this.$route.params.id)
  		console.log("getQuestionlists")
  		console.log(this.outputlist)
  	},
  	
  	async getQuestionlistInputfields(id)
  	{
      this.inputfields = []
  		console.log(this.selected_projectperiod.id)
  		let inputfields = await this.generalApiGetWithoutLoader("questionlists/all_inputfield_versions/"+id+"/"+this.selected_projectperiod.id)
      console.log("getQuestionlistInputfields")
      console.log(inputfields)
  		for(let inputfield of inputfields)
  		{
  			if(inputfield.name.length>20)
  			{
  				inputfield.short_name = inputfield.name.substring(0, 20)+"..."
  			}
  			else
  			{
  				inputfield.short_name = inputfield.name
  			}
  			
  		}
  		this.inputfields = await inputfields
  		this.inputfields_loaded = true
  		
  	},
  	async getProjectPeriods(id)
    {
      this.projectperiods = await this.generalApiGetWithoutLoader("projectperiods/"+id)
      this.periods_loaded = await true
    },
    async getNonconformityTypes(id)
    {
      this.nonconformitytypes = await this.generalApiGetWithoutLoader("questionlistnonconformitytypes/"+id)
      console.log("nonconformitytypes")
      console.log(this.nonconformitytypes)
      if(this.nonconformitytypes.length)
      {
        await this.nonconformitytypes.unshift({name:"Bütün Türler",id:"all"})
      }
      
      this.nonconformitytypes_loaded = await true
    },
  	async getQuestionlistSections(id)
  	{
  		
  		this.sections = await this.generalApiGetWithoutLoader("questionlists/section_versions/"+id+"/"+this.selected_projectperiod.id)
  		this.sections_loaded = true
  		console.log(this.sections)
  		
  	},
  	async removeItem(stack_id,type)
  	{
  		console.log(stack_id)
  		//console.log(this.$store.state.calculations.selectednode)
  		let node = this.sanitizeArray(this.$store.state.calculations.selectednode)
  		//console.log(node.data.outputs)
      //return false

  		node.data.outputs = node.data.outputs.filter((item)=>{return item.stack_id !==stack_id})
  		let nodes = this.$store.state.calculations.nodes
		let node_ind =  nodes.findIndex((item)=>{return item.id	 == node.id	})
		nodes[node_ind] = node
		this.$store.dispatch('calculations/setNodes',nodes)
		this.$store.dispatch('calculations/setSelectedNode',node)
  	},
  },
}
</script>

<style lang="css" scoped>
	.overloadtext {
        width: 400px;
        overflow:hidden; 
        white-space:nowrap; 
        text-overflow: ellipsis;
    }
</style>